import { ref } from "vue"
import { defineStore } from "pinia"
// import { Preferences } from "@capacitor/preferences"

// const PREF_KEY = "health-change-tokens"

// A lightweight mirror of native change tokens for UI/diagnostics.
// Native (Android) persists and advances tokens itself; this store is optional.
export const useHealthStore = defineStore("HealthStore", () => {
	// tokens: { [tokenKey: string]: string }
	const tokens = ref({})

	// async function loadTokens() {
	//   try {
	//     const { value } = await Preferences.get({ key: PREF_KEY })
	//     if (value) tokens.value = JSON.parse(value)
	//   } catch {
	//     tokens.value = {}
	//   }
	// }

	// async function persist() {
	// 	await Preferences.set({
	// 		key: PREF_KEY,
	// 		value: JSON.stringify(tokens.value),
	// 	})
	// }

	function getToken(tokenKey) {
		return tokens.value[tokenKey] || null
	}

	async function setToken(tokenKey, token) {
		tokens.value = { ...tokens.value, [tokenKey]: token }
		// await persist()
	}

	async function removeToken(tokenKey) {
		const copy = { ...tokens.value }
		delete copy[tokenKey]
		tokens.value = copy
		// await persist()
	}

	function listTokenKeys() {
		return Object.keys(tokens.value)
	}

	function getAllTokens() {
		return { ...tokens.value }
	}

	return {
		tokens,
		// loadTokens,
		getToken,
		setToken,
		removeToken,
		listTokenKeys,
		getAllTokens,
	}
})
